import AnnouncementsList from "./announcementsList";
import CustomPage from "./customPage";
import EventsList from "./eventsList";
import ViewEvent from "./eventsList/viewEvent";
import GalleryList from "./galleryList";
import GallerySingle from "./galleryList/gallerySingle";
import HomePage from "./homePage";

import NotFound from "./notFound";
import Programmes from "./programmes";
import Department from "./programmes/department";
import DepartmentList from "./programmes/departmentList";

export default {
  defaultlayout: [
    { path: "/", component: HomePage, exact: true },
    { path: "/programmes/:coursetype", component: Programmes, exact: true },
    { path: "/departments", component: DepartmentList, exact: true },
    { path: "/department/:id/:name", component: Department, exact: true },

    { path: "/gallery/:galleryId", component: GallerySingle },
    { path: "/gallery", component: GalleryList },
    { path: "/announcements-list", component: AnnouncementsList },

    { path: "/events/:type?", component: EventsList },
    { path: "/event/:id/:slug", component: ViewEvent },
    { path: "/:slug", component: CustomPage, exact: true },
    //{ path: "*", component: NotFound, exact: true },
  ],
};
